export const getAgencyYearsOfService = (date: Date) => {
    const memberSince = new Date(date);
    const currentDate = new Date();

    const yearsMember = currentDate.getFullYear() - memberSince.getFullYear();

    const year =
        currentDate.getMonth() > memberSince.getMonth() ||
        (currentDate.getMonth() === memberSince.getMonth() &&
            currentDate.getDate() >= memberSince.getDate())
            ? yearsMember
            : yearsMember - 1;

    return year === 0 ? 1 : year;
};
